import {createPlugin, createRoutableExtension,} from '@backstage/core-plugin-api';

import {rootRouteRef} from './routes';

export const pequiGithubActionsPlugin = createPlugin({
    id: 'pequi-github-actions',
    routes: {
        root: rootRouteRef,
    },
});

export const PequiEntityGithubActionsContent = pequiGithubActionsPlugin.provide(
    createRoutableExtension({
        name: 'PequiEntityGithubActionsContent',
        component: () => import('./components/Router').then(m => m.Router),
        mountPoint: rootRouteRef,
    }),
);
